import React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

export const LoadingOverlay: React.FC<{ children?: React.ReactNode, active?: boolean }> = ({ children, active = true }) => {
  return (
    <OverlayContainer>
      {children}
      {active && (
        <SpinnerWrapper>
          <Spin size="large" />
        </SpinnerWrapper>
      )}
    </OverlayContainer>
  );
};

const OverlayContainer = styled.div`
  /* display: contents, and not position: relative: when the overlay holds the map itself, the
     veil has to be placed against the map box. This wrapper has no height of its own, so the
     veil would collapse to zero and the spinner would sit at the top edge. */
  display: contents;
`;

const SpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 1000;
  /* The veil sits over the map but must not catch the pointer: otherwise the wheel over the
     map scrolls the page, and the map cannot be dragged, while a load is in flight. */
  pointer-events: none;
`;
